// Hosts that sign in through their own domain. nginx forwards /__/auth/ to Firebase there,
// and Google and Microsoft accept https://<host>/__/auth/handler as a return address. Safari on iOS blocks the
// storage of a frame from another domain, so signing in through firebaseapp.com never hands the login back to
// the app there (MD-1823). A host is only added here once both providers accept its return address: until
// then, sign-in on it would fail for everyone.
const OWN_AUTH_DOMAIN_HOSTS = new Set(['workspace.medendo.com', 'medendo-frontend.development.medendo.dev'])

/** The domain Firebase signs in through on `hostname`: its own where registered, else the Firebase one */
export function authDomainFor(hostname: string, firebaseAuthDomain: string): string {
    const host = hostname.toLowerCase()
    return OWN_AUTH_DOMAIN_HOSTS.has(host) ? host : firebaseAuthDomain
}
